// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReferralCode-module-referralBlock-ubdXg{margin-bottom:30px;margin-top:36px}@media(max-width: 959px){.ReferralCode-module-referralBlock-ubdXg{margin-bottom:32px;margin-top:50px}}.ReferralCode-module-header-jIcOT{margin-top:40px;margin-bottom:20px;font-size:26px;line-height:38px}@media(min-width: 960px){.ReferralCode-module-header-jIcOT{font-size:32px;line-height:44px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"referralBlock": "ReferralCode-module-referralBlock-ubdXg",
	"header": "ReferralCode-module-header-jIcOT"
};
export default ___CSS_LOADER_EXPORT___;
